
<template>

  <el-form-item class="okritem" :label="markItem.name" :label-width=labelbreedte :label-position="labelposition" id="markitem">

    <el-input v-if="markItem.tbl_sys_miscellaneous_mark_types[0].tbl_conf_mark.type === 'text'" size="small" style="width:175px;" v-model="selected[markItem.usersequence-1]"></el-input>
    <el-checkbox v-if="markItem.tbl_sys_miscellaneous_mark_types[0].tbl_conf_mark.type === 'check'" v-model="selected[markItem.usersequence-1]"></el-checkbox>
    <el-select v-if="markItem.tbl_sys_miscellaneous_mark_types[0].tbl_conf_mark.type === 'select'" v-model="selected[markItem.usersequence-1]" placeholder="Select">
      <el-option
        v-for="item in JSON.parse(markItem.tbl_sys_miscellaneous_mark_types[0].tbl_conf_mark.mark)"
        :label="item"
        :value="item"
        :key="item">
      </el-option>
    </el-select>

  </el-form-item>
</template>

<script>


export default {
    name: 'markitem',
    props:['markItem','selected','labelbreedte','labelposition'],
    created: function() {
        //this.getUnits()

    },

    data: function() {
        return {
            tableData: []

        }
    },
    methods: {

    }
}
</script>
